import React, { useEffect, useState } from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import SEOHead from "../components/SEOHead";
import CitabilitySection from "../components/CitabilitySection";
import axios from "axios";
import { API_URL } from "../config";

interface PortfolioData {
  pdf?: string;
}

const Portfolio: React.FC = () => {
  const [portfolio, setPortfolio] = useState<PortfolioData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const portfolioIntro =
    "了解 CosyLab 工作坊目錄涵蓋的課程主題與教學方向，並下載最新課程 PDF 作內部規劃參考。";

  useEffect(() => {
    fetchPortfolio();
  }, []);

  const fetchPortfolio = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/portfolio`);
      setPortfolio(response.data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch portfolio");
    } finally {
      setLoading(false);
    }
  };
  const portfolioPdfUrl = portfolio?.pdf
    ? portfolio.pdf.startsWith("http")
      ? portfolio.pdf
      : `${API_URL}${portfolio.pdf}`
    : null;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <SEOHead
        title="工作坊目錄 - CosyLab"
        description="瀏覽 CosyLab 工作坊目錄，了解到校課程主題、教學方向與可下載的課程資料。"
        canonical="https://cosylabdesigns.com/portfolio"
      />
      <Typography
        variant="h1"
        sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2rem", md: "2.5rem" } }}
      >
        工作坊目錄
      </Typography>

      <Typography variant="body1" sx={{ mb: 3, maxWidth: 720 }}>
        {portfolioIntro}
      </Typography>

      <Box sx={{ textAlign: "center", py: 3 }}>
        <Typography variant="h4" gutterBottom>
          下載最新目錄
        </Typography>

        {loading && (
          <Typography color="text.secondary">正在載入最新目錄資料...</Typography>
        )}

        {!loading && error && (
          <Typography color="error" sx={{ maxWidth: 640, mx: "auto" }}>
            目前未能載入 PDF，但你仍可先瀏覽目錄說明並稍後再試。
          </Typography>
        )}

        {!loading && portfolioPdfUrl ? (
          <Button
            variant="contained"
            color="primary"
            href={portfolioPdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mt: 2 }}
          >
            下載工作坊目錄 PDF
          </Button>
        ) : (
          !loading &&
          !error && (
            <Typography color="text.secondary">
              目前尚未提供可下載的目錄檔案，請稍後再查看。
            </Typography>
          )
        )}
      </Box>

      <CitabilitySection routeKey="/portfolio" />
    </Container>
  );
};

export default Portfolio;
